import { AxiosResponse } from 'axios';

import { axiosClient } from '../config/axios-client';

const BASE_API_PATH = '/notes';

class BotNoteStore {
  public updateBotNote = (
    botId: string,
    note: string,
  ): Promise<AxiosResponse<string>> =>
    axiosClient.put(`${BASE_API_PATH}/${botId}`, null, {
      params: { note },
    });
}

const botNoteStore = new BotNoteStore();
export default botNoteStore;
